export default class SubscriptionCreateRequest {
  public billingPriceId: string;
  public taxRateId: string;
  public quota: number | undefined;
  public smsUnitAmount: number;
  public overageUnitAmount: number | undefined;
  public quotaRenewal: 'month' | 'year';
  public kind: number;

  constructor(options) {
    this.billingPriceId = options.billingPriceId;
    this.taxRateId = options.taxRateId;
    this.kind = parseInt(options.kind, 10);
    this.quota = parseInt(options.quota, 10);
    this.quotaRenewal = options.quotaRenewal;
    this.smsUnitAmount = parseInt(options.smsUnitAmount, 10);
    if (options.overageUnitAmount) {
      this.overageUnitAmount = parseInt(options.overageUnitAmount, 10);
    }
  }

  complete(billingPrice) {
    if (billingPrice.payg()) {
      return (
        this.billingPriceId
        && this.smsUnitAmount
        && this.kind > 0
      );
    }

    return (
      this.billingPriceId
      && this.quota
      && this.quotaRenewal
      && this.smsUnitAmount
      && this.overageUnitAmount
      && this.kind > 0
    );
  }
}
